import { Empty, Tag } from "antd";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setKeyValue } from "../../../../store/chats/slice";
import { ChatLeftSkeleton } from "./ChatSkeleton";
import { useChats } from "../../../../hooks/useChats";
import ConvListItem from "./ConvListItem";

const ConversionList = () => {
  const { chats, loading, selectedChatId, newMessageCount } = useChats();

  const dispatch = useDispatch();

  useEffect(() => {
    if (newMessageCount) {
      dispatch(
        setKeyValue({
          key: "newMessageCount",
          value: 0,
        }),
      );
    }
  }, [newMessageCount]);

  return (
    <div className="left-panel">
      <div className="panel-header">
        <div className="section-title">Conversations</div>
      </div>
      <div className="chat-container">
        {loading ? (
          <ChatLeftSkeleton />
        ) : chats?.length ? (
          chats.map((chat, i) => (
            <ConvListItem chat={chat} selectedChatId={selectedChatId} key={i} />
          ))
        ) : (
          <Empty
            description="No conversations found"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        )}
      </div>
    </div>
  );
};

export default ConversionList;
